export * from './IconPhoto';
